import { API_ADDRESS } from "../../constants";
import { Inject, Injectable } from "@angular/core";
import { DbTable } from './DbTable';
import { CallService, CallInteraction } from '../../models/call-service.model';
import { EnumCallServiceDirection } from '../../enums';
import { HttpClient } from '@angular/common/http';


export class DbCallServices
extends DbTable<CallService> {

    constructor(public _http: HttpClient, public controllerPath:string)  {

        super(_http, controllerPath);

    }
  
}


export class DbCallInteractions extends DbTable<CallInteraction> {

    constructor(public _http: HttpClient, public id:number)  {

        super(_http, `call_services/${id}/call_interactions`);

    }
  
    public addInteraction(employeeId:number,status:number,content:string,name:string,direction:EnumCallServiceDirection )
    {
        console.log("Adicionando");

        
    
        let body = {
            EmployeeId : employeeId,
            Status: status,
            Content:content,
            Author:name,
            Direction:<number>direction
        }

        console.log("Postando body");
        console.log(body);


        // let requestOptions = new RequestOptions({ method: RequestMethod.Post });
        // requestOptions.headers = new Headers({ 'Content-Type': 'application/json' })
    
        return this._http.post(API_ADDRESS + `/${this._controllerName}/add`, body)
            .toPromise();
           // .then(result => result.json())
    }
   
}


// constructor(public _http: Http, public _companyId:number)  {

//     super(_http, `Companies/${_companyId}/PaymentTypes`);



//   public _controllerName = "purchases";


 

//     constructor(private _http: Http) {
    
//     }

//     public getList(customerId: number, startPos: number, length: number, searchText: string): Promise<Purchase[]> {

//         console.log("getList");

//         searchText += "";
//         return this._http.get(API_ADDRESS + `/Purchases/${customerId}/search/${startPos}/${length}/${searchText}`)
//             .map((result: any) => {
//                 let purchaseList: Purchase[] = result.json();

//                 purchaseList.forEach(x => {
//                     x.PurchaseDate = new Date(x.PurchaseDate);
//                 });
//                 return purchaseList;
                
//             }).toPromise();
//     }


//     public  update(purchase: Purchase): any {
 
  

//         let body = JSON.stringify(purchase);
    
//         if (purchase.Id > 0) {
//             let requestOptions = new RequestOptions({ method: RequestMethod.Put });
//             requestOptions.headers = new Headers({ 'Content-Type': 'application/json' })
      
//             return this._http.post(API_ADDRESS + `/${this._controllerName}/${purchase.Id}`, body, requestOptions)
//                 .toPromise()
//                 .then(result => 
//                     {
//                         console.log(API_ADDRESS + `/${this._controllerName}/${purchase.Id}`);
//                       console.log(result.json());
   
//                       return  result.json();
//                     }
//                 )
//                 .catch(error => {
//                     console.log("Errooooooooo....");
//                     console.log(error);
//                 })
   
//         }
//         else {
   
//             console.log(" postlicense(");
//         console.log(purchase);
        
//             let requestOptions = new RequestOptions({ method: RequestMethod.Post });
//             requestOptions.headers = new Headers({ 'Content-Type': 'application/json' })
   
//             return this._http.post(API_ADDRESS + `/${this._controllerName}`, body, requestOptions)
//                 .toPromise()
//                 .then(result => result.json())
           
//         }
   
//      }


//      public getPurchase(id: number): Promise<Purchase> {
//         return this._http.get(API_ADDRESS + `/${this._controllerName}/` + `${id}`)
//             .map((result: any) => {
                  
//                 result =  result.json();

//                 return result;
//             }).toPromise();
//      }


// }